// Mock data for the employee management system

import { useSelector } from "react-redux";

// Employee data


export const employees = [
  { id: 1, name: '김경준', nickname: '대표', years: 4, role: '대표', permission: 'master' },
  { id: 2, name: '박창훈', nickname: '찰리', years: 2, role: '소장', permission: 'submaster' },
  { id: 3, name: '양승열', nickname: '케이', years: 1, role: '운영직원', permission: 'manager' },
  { id: 4, name: '양승찬', nickname: '에이', years: 1, role: '알바', permission: 'employee' },
  { id: 5, name: '장은희', nickname: '체리', years: 1, role: '다림직원', permission: 'employee' },
  { id: 6, name: '정민현', nickname: 'Q', years: 3, role: '배송직원', permission: 'employee' },
];

// Attendance data
export const attendanceRecords = [
  {
    id: 1,
    employeeId: 1,
    date: '2024-12-05',
    season: '평시',
    roleType: '대표',
    holiday: '',
    scheduledStart: '08:00',
    scheduledEnd: '18:00',
    actualStart: '07:12',
    actualEnd: '',
    status: '퇴근',
    breakTime: '12:00 ~ 13:00',
    requestedOvertime: '0:00',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 2,
    employeeId: 2,
    date: '2024-12-05',
    season: '준비수기',
    roleType: '소장',
    holiday: '',
    scheduledStart: '07:00',
    scheduledEnd: '18:00',
    actualStart: '06:57',
    actualEnd: '',
    status: '퇴근',
    breakTime: '12:30 ~ 13:30',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 3,
    employeeId: 3,
    date: '2024-12-05',
    season: '준비수기',
    roleType: '운영직원',
    holiday: '',
    scheduledStart: '08:00',
    scheduledEnd: '17:00',
    actualStart: '',
    actualEnd: '',
    status: '퇴근',
    breakTime: '12:00 ~ 13:00',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 4,
    employeeId: 4,
    date: '2024-12-05',
    season: '준비수기',
    roleType: '알바',
    holiday: '',
    scheduledStart: '13:00',
    scheduledEnd: '16:00',
    actualStart: '',
    actualEnd: '',
    status: '퇴근',
    breakTime: '',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 5,
    employeeId: 5,
    date: '2024-12-05',
    season: '비수기',
    roleType: '다림직원',
    holiday: '',
    scheduledStart: '09:00',
    scheduledEnd: '18:00',
    actualStart: '',
    actualEnd: '',
    status: '퇴근',
    breakTime: '12:00 ~ 13:00',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 6,
    employeeId: 6,
    date: '2024-12-05',
    season: '평시',
    roleType: '배송직원',
    holiday: '',
    scheduledStart: '17:00',
    scheduledEnd: '',
    actualStart: '',
    actualEnd: '',
    status: '퇴근',
    breakTime: '',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  // December 6
  {
    id: 7,
    employeeId: 1,
    date: '2024-12-06',
    season: '평시',
    roleType: '대표',
    holiday: '',
    scheduledStart: '',
    scheduledEnd: '',
    actualStart: '',
    actualEnd: '',
    status: '근무중',
    breakTime: '',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 8,
    employeeId: 2,
    date: '2024-12-06',
    season: '준비수기',
    roleType: '소장',
    holiday: '',
    scheduledStart: '',
    scheduledEnd: '',
    actualStart: '',
    actualEnd: '',
    status: '근무중',
    breakTime: '',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 1,
    employeeId: 1,
    date: '2024-12-05',
    season: '평시',
    roleType: '대표',
    holiday: '',
    scheduledStart: '08:00',
    scheduledEnd: '18:00',
    actualStart: '07:12',
    actualEnd: '',
    status: '퇴근',
    breakTime: '12:00 ~ 13:00',
    requestedOvertime: '0:00',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 2,
    employeeId: 2,
    date: '2024-12-05',
    season: '준비수기',
    roleType: '소장',
    holiday: '',
    scheduledStart: '07:00',
    scheduledEnd: '18:00',
    actualStart: '06:57',
    actualEnd: '',
    status: '퇴근',
    breakTime: '12:30 ~ 13:30',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 3,
    employeeId: 3,
    date: '2024-12-05',
    season: '준비수기',
    roleType: '운영직원',
    holiday: '',
    scheduledStart: '08:00',
    scheduledEnd: '17:00',
    actualStart: '',
    actualEnd: '',
    status: '퇴근',
    breakTime: '12:00 ~ 13:00',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 4,
    employeeId: 4,
    date: '2024-12-05',
    season: '준비수기',
    roleType: '알바',
    holiday: '',
    scheduledStart: '13:00',
    scheduledEnd: '16:00',
    actualStart: '',
    actualEnd: '',
    status: '퇴근',
    breakTime: '',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 5,
    employeeId: 5,
    date: '2024-12-05',
    season: '비수기',
    roleType: '다림직원',
    holiday: '',
    scheduledStart: '09:00',
    scheduledEnd: '18:00',
    actualStart: '',
    actualEnd: '',
    status: '퇴근',
    breakTime: '12:00 ~ 13:00',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 6,
    employeeId: 6,
    date: '2024-12-05',
    season: '평시',
    roleType: '배송직원',
    holiday: '',
    scheduledStart: '17:00',
    scheduledEnd: '',
    actualStart: '',
    actualEnd: '',
    status: '퇴근',
    breakTime: '',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  // December 6
  {
    id: 7,
    employeeId: 1,
    date: '2024-12-06',
    season: '평시',
    roleType: '대표',
    holiday: '',
    scheduledStart: '',
    scheduledEnd: '',
    actualStart: '',
    actualEnd: '',
    status: '근무중',
    breakTime: '',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 8,
    employeeId: 2,
    date: '2024-12-06',
    season: '준비수기',
    roleType: '소장',
    holiday: '',
    scheduledStart: '',
    scheduledEnd: '',
    actualStart: '',
    actualEnd: '',
    status: '근무중',
    breakTime: '',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 1,
    employeeId: 1,
    date: '2024-12-05',
    season: '평시',
    roleType: '대표',
    holiday: '',
    scheduledStart: '08:00',
    scheduledEnd: '18:00',
    actualStart: '07:12',
    actualEnd: '',
    status: '퇴근',
    breakTime: '12:00 ~ 13:00',
    requestedOvertime: '0:00',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 2,
    employeeId: 2,
    date: '2024-12-05',
    season: '준비수기',
    roleType: '소장',
    holiday: '',
    scheduledStart: '07:00',
    scheduledEnd: '18:00',
    actualStart: '06:57',
    actualEnd: '',
    status: '퇴근',
    breakTime: '12:30 ~ 13:30',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 3,
    employeeId: 3,
    date: '2024-12-05',
    season: '준비수기',
    roleType: '운영직원',
    holiday: '',
    scheduledStart: '08:00',
    scheduledEnd: '17:00',
    actualStart: '',
    actualEnd: '',
    status: '퇴근',
    breakTime: '12:00 ~ 13:00',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 4,
    employeeId: 4,
    date: '2024-12-05',
    season: '준비수기',
    roleType: '알바',
    holiday: '',
    scheduledStart: '13:00',
    scheduledEnd: '16:00',
    actualStart: '',
    actualEnd: '',
    status: '퇴근',
    breakTime: '',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 5,
    employeeId: 5,
    date: '2024-12-05',
    season: '비수기',
    roleType: '다림직원',
    holiday: '',
    scheduledStart: '09:00',
    scheduledEnd: '18:00',
    actualStart: '',
    actualEnd: '',
    status: '퇴근',
    breakTime: '12:00 ~ 13:00',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 6,
    employeeId: 6,
    date: '2024-12-05',
    season: '평시',
    roleType: '배송직원',
    holiday: '',
    scheduledStart: '17:00',
    scheduledEnd: '',
    actualStart: '',
    actualEnd: '',
    status: '퇴근',
    breakTime: '',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  // December 6
  {
    id: 7,
    employeeId: 1,
    date: '2024-12-06',
    season: '평시',
    roleType: '대표',
    holiday: '',
    scheduledStart: '',
    scheduledEnd: '',
    actualStart: '',
    actualEnd: '',
    status: '근무중',
    breakTime: '',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  {
    id: 8,
    employeeId: 2,
    date: '2024-12-06',
    season: '준비수기',
    roleType: '소장',
    holiday: '',
    scheduledStart: '',
    scheduledEnd: '',
    actualStart: '',
    actualEnd: '',
    status: '근무중',
    breakTime: '',
    requestedOvertime: '',
    totalWorkHours: '',
    nightWorkHours: '',
    lateHours: '',
    additionalWorkHours: '',
  },
  // Add more records for remaining days and employees...
];

// Task data
export const taskRecords = [
  {
    id: 1,
    employeeId: 1,
    date: '2024-12-05',
    taskType: '다림질',
    startTime: '08:15',
    endTime: '10:30',
    totalDuration: '02:15',
    count: 18,
    averageTimePerItem: '00:07.5',
    comparedToAverage: 'above',
  },
  {
    id: 2,
    employeeId: 2,
    date: '2024-12-05',
    taskType: '신발세탁',
    startTime: '09:00',
    endTime: '11:45',
    totalDuration: '02:45',
    count: 12,
    averageTimePerItem: '00:13.75',
    comparedToAverage: 'below',
  },
  {
    id: 3,
    employeeId: 1,
    date: '2024-12-06',
    taskType: '1차포장',
    startTime: '08:30',
    endTime: '11:00',
    totalDuration: '02:30',
    count: 45,
    averageTimePerItem: '00:03.33',
    comparedToAverage: 'average',
  },
  {
    id: 4,
    employeeId: 3,
    date: '2024-12-06',
    taskType: '검수',
    startTime: '13:30',
    endTime: '16:00',
    totalDuration: '02:30',
    count: 75,
    averageTimePerItem: '00:02',
    comparedToAverage: 'above',
  },
  // Add more task records...
];

// Permission levels
export const permissionLevels = {
  A1: {
    name: '마스터',
    description: '본인 및 근무자들 (직원들) 모두의 모든 데이터를 확인할 수 있고 수정도 할 수 있음 (전체 관리자)',
    canView: 'all',
    canEdit: true,
  },
  A2: {
    name: '서브마스터',
    description: '본인 및 근무자들(직원들) 모두의 모든 데이터를 확인 할 수 있음 (수정은 안됨)',
    canView: 'all',
    canEdit: false,
  },
  A3: {
    name: '매니저',
    description: '본인 및 직급이 \'알바\'인 사람들의 모든 데이터를 확인 할 수 있음(수정안 안됨) (볼수없는 항목은 총근무시간합, 연장근무시간)',
    canView: 'partemployee',
    canEdit: false,
    hiddenFields: ['totalWorkHours', 'requestedOvertime'],
  },
  A4: {
    name: '직원',
    description: '본인의 데이터를 확인할 수 있음 (수정은 안됨) (볼수없는 항목은 총근무시간합, 연장근무시간)',
    canView: 'self',
    canEdit: false,
    hiddenFields: ['totalWorkHours', 'requestedOvertime'],
  },
};

// Task types
export const taskTypes = [
  '다림질',
  '신발세탁',
  '1차포장',
  '2차포장',
  '검수',
];

// Generate more detailed data for charts and examples
export const generateMockDataForDateRange = (startDate, endDate) => {
  // Implementation would go here to generate data for a specific date range
  // This would be useful for the date range filtering functionality
};
